import { EMPTY_ACTION } from '../../app/store'
import { getTabId } from '../../utils/common'
import {
  CLEAR_ALERT_ADDED,
  CLEAR_PATIENT_CHART,
  CLEAR_PATIENT_DATA,
  CLEAR_PATIENT_LIST,
  SET_ALLERGY_NAME_ERROR,
  SET_ERROR,
  CLEAR_PATIENT_CHART_TREAT_LINK,
  SET_IS_CHANGED_VISIT_STATUS_SUCCESS,
  SET_PAST_VISIT_TREAT_LINK,
  CLEAR_PAST_VISIT_INFO_DATA,
  SET_IS_PHONE_CORRECT,
  SET_IS_PHARMACY_SEARCHING_DONE,
  RESET_SEARCH_PHARMACY_LIST,
  SET_IS_ACCOUNT_INFO_UPDATED_SUCCESS,
  SET_IS_NOTE_ADDENDUM_SUCCESS_ADDED,
  SET_IS_PATIENT_INSTRUCTIONS_ADDENDUM_SUCCESS_ADDED,
  DROP_ERROR,
  ADD_MEDIA_FILE_SUCCESS,
  SET_VISIT_PROVIDER,
  SET_ICD_CODES_UPDATE_SUCCESS,
  SET_PATIENT_ID_FOR_RESET_MEDIA_FILES,
  SET_IS_NEED_TO_UPDATE_PAST_VISITS,
  SET_UPCOMING_VISIT_NOTE,
  SET_PATIENT_INSTRUCTION,
  DELETE_PATIENT_ALLERGY_FROM_STORAGE,
} from './ChartsConstants'

export const clearChartPatientList = () => ({
  type: CLEAR_PATIENT_LIST,
})

export function clearChartPatient() {
  return {
    type: CLEAR_PATIENT_CHART,
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function setICDCodeUpdateSuccess(value, visitId) {
  return {
    type: SET_ICD_CODES_UPDATE_SUCCESS,
    payload: { value, visitId },
  }
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export function setChartError({ errorMsg, patientId = null, visitId = null, tabId }) {
  const currentTabId = getTabId()

  if (currentTabId === tabId) {
    return {
      type: SET_ERROR,
      payload: errorMsg,
      extraData: { patientId, visitId, tabId },
    }
  }
  return {
    type: EMPTY_ACTION,
  }
}

export const dropChartError = () => ({
  type: DROP_ERROR,
  payload: '',
})

export const dropMediaFileSuccess = () => ({
  type: ADD_MEDIA_FILE_SUCCESS,
  payload: undefined,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setAllergyNameError = (errorMsg) => ({
  type: SET_ALLERGY_NAME_ERROR,
  payload: errorMsg,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setPastVisitTreatLink = (linkValue) => ({
  type: SET_PAST_VISIT_TREAT_LINK,
  payload: linkValue || '',
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setIsChangedVisitStatusSuccess = (value, visitId) => ({
  type: SET_IS_CHANGED_VISIT_STATUS_SUCCESS,
  payload: { newStatus: value || false, visitId },
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setIsPhoneCorrect = (value, number) => ({
  type: SET_IS_PHONE_CORRECT,
  payload: { isCorrect: value || false, number },
})

export function clearAlertSuccess() {
  return {
    type: CLEAR_ALERT_ADDED,
  }
}

export function clearPastVisitInfoData() {
  return {
    type: CLEAR_PAST_VISIT_INFO_DATA,
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function clearPatientData(patientId, tabId) {
  const currentTabId = getTabId()

  if (currentTabId === tabId) {
    return {
      type: CLEAR_PATIENT_DATA,
      payload: patientId,
    }
  }
  return {
    type: EMPTY_ACTION,
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function clearPatientChartTreatLink(id) {
  return {
    type: CLEAR_PATIENT_CHART_TREAT_LINK,
    payload: id,
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setIsPharmacySearchingDone = (value) => {
  const action = {
    type: SET_IS_PHARMACY_SEARCHING_DONE,
    payload: value,
  }
  return action
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setIsAccountInfoUpdatedSuccess = (value) => {
  const action = {
    type: SET_IS_ACCOUNT_INFO_UPDATED_SUCCESS,
    payload: value || false,
  }
  return action
}

export const resetPharmacySearchList = () => {
  const action = {
    type: RESET_SEARCH_PHARMACY_LIST,
  }
  return action
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setIsNoteAddendumSuccessfullyAdded = (newStatus, visitId) => ({
  type: SET_IS_NOTE_ADDENDUM_SUCCESS_ADDED,
  payload: { newStatus, visitId },
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setIsPatientInstructionsAddendumSuccessfullyAdded = (newStatus, visitId) => ({
  type: SET_IS_PATIENT_INSTRUCTIONS_ADDENDUM_SUCCESS_ADDED,
  payload: { newStatus, visitId },
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setVisitProvider = (provider, visitId) => ({
  type: SET_VISIT_PROVIDER,
  payload: { provider, visitId },
})

export const setPatientIdForResetMediaFiles = (value = null) => ({
  type: SET_PATIENT_ID_FOR_RESET_MEDIA_FILES,
  payload: value,
})

export const setIsNeedToUpdatedPastVisits = (value = false) => ({
  type: SET_IS_NEED_TO_UPDATE_PAST_VISITS,
  payload: value,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setUpcomingVisitNote = (visitId, note = null) => ({
  type: SET_UPCOMING_VISIT_NOTE,
  payload: { visitId, note },
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setPatientInstruction = (visitId, instruction = null) => ({
  type: SET_PATIENT_INSTRUCTION,
  payload: { visitId, instruction },
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const deleteAllergyFromStorage = (patientId, allergyId) => ({
  type: DELETE_PATIENT_ALLERGY_FROM_STORAGE,
  extraData: { patientId, allergyId },
})
